import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { Table, Header, Form, Loader, Icon } from 'semantic-ui-react';
import { DatesRangeInput } from 'semantic-ui-calendar-react-17';
import PropTypes from 'prop-types';
import moment from 'moment';
import momentDurationFormatSetup from 'moment-duration-format';
import 'moment/locale/pt-br';
import { PaginationContainer } from '../../components/PaginationContainer';
import _ from 'lodash';
import { reportActions } from '../../actions/report.actions';

const DATE_FORMAT = 'DD/MM/YYYY';
const FILTER_FORMAT = 'YYYY-MM-DD';

function formatDuration(seconds) {
  return moment.duration(seconds || 0, 'seconds').format('HH:mm:ss', { trim: false });
}

class ActivitySummaryScreen extends Component {
  constructor(props) {
    super(props);

    this.state = {
      page: 1,
      search: '',
      period: '',
    };
  }

  static get propTypes() {
    return {
      registers: PropTypes.any,
      loading: PropTypes.bool,
    };
  }

  componentDidMount() {
    this.handleSearchDebounced = _.debounce(function () {
      this.fetchRegisters();
    }, 500);
    const today = moment().format(DATE_FORMAT);
    this.setState({ period: `${today} - ${today}` }, () => this.fetchRegisters());
  }

  handlePageChange(activePage) {
    this.setState({ page: activePage }, () => this.fetchRegisters());
  }

  handlePeriodChange(period) {
    this.setState({ period, page: 1 }, () => this.fetchRegisters());
  }

  fetchRegisters(isExport) {
    const { dispatch } = this.props;
    const { page, search, period } = this.state;
    var [startDate, endDate] = (period || '').split(' - ');
    if (startDate) {
      startDate = moment(startDate, DATE_FORMAT).format(FILTER_FORMAT);
    }

    if (endDate) {
      endDate = moment(endDate, DATE_FORMAT).format(FILTER_FORMAT);
    }

    dispatch(reportActions.fetchActivitySummary({ page, username: search, startDate, endDate, export: isExport ? true : null }));
  }

  handleChange(field, data) {
    const state = this.state;
    state[field] = data;
    state.page = 1;
    this.setState(state);
    this.handleSearchDebounced();
  }

  exportXlsx() {
    this.fetchRegisters(true);
  }

  render() {
    const { registers, loading } = this.props;
    const { period } = this.state;

    return (
      <Fragment>
        <Header>
          <h1>Resumo de Sessões</h1>
        </Header>
        <Loader active={loading} />
        <Form>
          <Form.Group>
            <DatesRangeInput
              name="period"
              localization="pt-br"
              placeholder="Período"
              value={period}
              iconPosition="left"
              dateFormat={DATE_FORMAT}
              label="Período"
              closable={true}
              clearable={true}
              onChange={(e, data) => this.handlePeriodChange(data.value)}
            />
            <Form.Input icon="search" label="Username" onChange={(e, data) => this.handleChange('search', data.value)} loading={loading} />

            <Form.Button onClick={() => this.exportXlsx()} label="&nbsp;">
              <Icon name="file excel" /> Exportar
            </Form.Button>
          </Form.Group>
        </Form>

        {registers && registers.Results && registers.Results.length > 0 && (
          <Table compact>
            <Table.Header>
              <Table.Row>
                <Table.HeaderCell>Data</Table.HeaderCell>
                <Table.HeaderCell>Usuário</Table.HeaderCell>
                <Table.HeaderCell>Username</Table.HeaderCell>
                <Table.HeaderCell>Tempo Ativo</Table.HeaderCell>
                <Table.HeaderCell>Tempo Bloqueado</Table.HeaderCell>
                <Table.HeaderCell>Primeira Atividade</Table.HeaderCell>
                <Table.HeaderCell>Última Atividade</Table.HeaderCell>
                <Table.HeaderCell>Intervalos</Table.HeaderCell>
              </Table.Row>
            </Table.Header>
            <Table.Body>
              {registers.Results.map((register) => {
                return (
                  <Table.Row key={`${register.UserId}-${register.Date}`}>
                    <Table.Cell>{moment(register.Date).format('DD/MM/YYYY')}</Table.Cell>
                    <Table.Cell>{register.Name}</Table.Cell>
                    <Table.Cell>{register.Username}</Table.Cell>
                    <Table.Cell>{formatDuration(register.OpenSeconds)}</Table.Cell>
                    <Table.Cell>{formatDuration(register.LockedSeconds)}</Table.Cell>
                    <Table.Cell>{register.FirstStart ? moment(register.FirstStart).format('DD/MM/YYYY HH:mm:ss') : '-'}</Table.Cell>
                    <Table.Cell>{register.LastEnd ? moment(register.LastEnd).format('DD/MM/YYYY HH:mm:ss') : '-'}</Table.Cell>
                    <Table.Cell>{register.IntervalCount}</Table.Cell>
                  </Table.Row>
                );
              })}
            </Table.Body>
          </Table>
        )}
        <PaginationContainer registers={registers} onPageChange={(e, { activePage }) => this.handlePageChange(activePage)} />
      </Fragment>
    );
  }
}

function mapStateToProps(state) {
  const { report } = state;

  return {
    registers: report?.activitySummary || null,
    loading: report?.loading,
  };
}

const connectedActivitySummaryScreen = connect(mapStateToProps)(ActivitySummaryScreen);
export { connectedActivitySummaryScreen as ActivitySummaryScreen };
